/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSlugRouteImport } from './routes/_authenticated/$slug'
import { Route as AuthenticatedSlugIndexRouteImport } from './routes/_authenticated/$slug/index'
import { Route as AuthenticatedSlugSettingsRouteImport } from './routes/_authenticated/$slug/settings'
import { Route as AuthenticatedSlugPackagesRouteImport } from './routes/_authenticated/$slug/packages'
import { Route as AuthenticatedSlugMessagesRouteImport } from './routes/_authenticated/$slug/messages'
import { Route as AuthenticatedSlugMaintenanceRouteImport } from './routes/_authenticated/$slug/maintenance'
import { Route as AuthenticatedSlugLobbyRouteImport } from './routes/_authenticated/$slug/lobby'
import { Route as AuthenticatedSlugBroadcastsRouteImport } from './routes/_authenticated/$slug/broadcasts'
import { Route as AuthenticatedSlugSettingsIndexRouteImport } from './routes/_authenticated/$slug/settings/index'
import { Route as AuthenticatedSlugSettingsTemplatesRouteImport } from './routes/_authenticated/$slug/settings/templates'
import { Route as AuthenticatedSlugSettingsSegmentsRouteImport } from './routes/_authenticated/$slug/settings/segments'
import { Route as AuthenticatedSlugSettingsPropertiesRouteImport } from './routes/_authenticated/$slug/settings/properties'
import { Route as AuthenticatedSlugSettingsOrganizationRouteImport } from './routes/_authenticated/$slug/settings/organization'
import { Route as AuthenticatedSlugSettingsImportRouteImport } from './routes/_authenticated/$slug/settings/import'
import { Route as AuthenticatedSlugSettingsDebugRouteImport } from './routes/_authenticated/$slug/settings/debug'
import { Route as AuthenticatedSlugSettingsContactsRouteImport } from './routes/_authenticated/$slug/settings/contacts'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSlugRoute = AuthenticatedSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSlugIndexRoute = AuthenticatedSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugSettingsRoute =
  AuthenticatedSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugPackagesRoute =
  AuthenticatedSlugPackagesRouteImport.update({
    id: '/packages',
    path: '/packages',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugMessagesRoute =
  AuthenticatedSlugMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugMaintenanceRoute =
  AuthenticatedSlugMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugLobbyRoute = AuthenticatedSlugLobbyRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugBroadcastsRoute =
  AuthenticatedSlugBroadcastsRouteImport.update({
    id: '/broadcasts',
    path: '/broadcasts',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugSettingsIndexRoute =
  AuthenticatedSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsTemplatesRoute =
  AuthenticatedSlugSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsSegmentsRoute =
  AuthenticatedSlugSettingsSegmentsRouteImport.update({
    id: '/segments',
    path: '/segments',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsPropertiesRoute =
  AuthenticatedSlugSettingsPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsOrganizationRoute =
  AuthenticatedSlugSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsImportRoute =
  AuthenticatedSlugSettingsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsDebugRoute =
  AuthenticatedSlugSettingsDebugRouteImport.update({
    id: '/debug',
    path: '/debug',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)
const AuthenticatedSlugSettingsContactsRoute =
  AuthenticatedSlugSettingsContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedSlugSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/$slug/broadcasts': typeof AuthenticatedSlugBroadcastsRoute
  '/$slug/lobby': typeof AuthenticatedSlugLobbyRoute
  '/$slug/maintenance': typeof AuthenticatedSlugMaintenanceRoute
  '/$slug/messages': typeof AuthenticatedSlugMessagesRoute
  '/$slug/packages': typeof AuthenticatedSlugPackagesRoute
  '/$slug/settings': typeof AuthenticatedSlugSettingsRouteWithChildren
  '/$slug/': typeof AuthenticatedSlugIndexRoute
  '/$slug/settings/contacts': typeof AuthenticatedSlugSettingsContactsRoute
  '/$slug/settings/debug': typeof AuthenticatedSlugSettingsDebugRoute
  '/$slug/settings/import': typeof AuthenticatedSlugSettingsImportRoute
  '/$slug/settings/organization': typeof AuthenticatedSlugSettingsOrganizationRoute
  '/$slug/settings/properties': typeof AuthenticatedSlugSettingsPropertiesRoute
  '/$slug/settings/segments': typeof AuthenticatedSlugSettingsSegmentsRoute
  '/$slug/settings/templates': typeof AuthenticatedSlugSettingsTemplatesRoute
  '/$slug/settings/': typeof AuthenticatedSlugSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug/broadcasts': typeof AuthenticatedSlugBroadcastsRoute
  '/$slug/lobby': typeof AuthenticatedSlugLobbyRoute
  '/$slug/maintenance': typeof AuthenticatedSlugMaintenanceRoute
  '/$slug/messages': typeof AuthenticatedSlugMessagesRoute
  '/$slug/packages': typeof AuthenticatedSlugPackagesRoute
  '/$slug': typeof AuthenticatedSlugIndexRoute
  '/$slug/settings/contacts': typeof AuthenticatedSlugSettingsContactsRoute
  '/$slug/settings/debug': typeof AuthenticatedSlugSettingsDebugRoute
  '/$slug/settings/import': typeof AuthenticatedSlugSettingsImportRoute
  '/$slug/settings/organization': typeof AuthenticatedSlugSettingsOrganizationRoute
  '/$slug/settings/properties': typeof AuthenticatedSlugSettingsPropertiesRoute
  '/$slug/settings/segments': typeof AuthenticatedSlugSettingsSegmentsRoute
  '/$slug/settings/templates': typeof AuthenticatedSlugSettingsTemplatesRoute
  '/$slug/settings': typeof AuthenticatedSlugSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/_authenticated/$slug/broadcasts': typeof AuthenticatedSlugBroadcastsRoute
  '/_authenticated/$slug/lobby': typeof AuthenticatedSlugLobbyRoute
  '/_authenticated/$slug/maintenance': typeof AuthenticatedSlugMaintenanceRoute
  '/_authenticated/$slug/messages': typeof AuthenticatedSlugMessagesRoute
  '/_authenticated/$slug/packages': typeof AuthenticatedSlugPackagesRoute
  '/_authenticated/$slug/settings': typeof AuthenticatedSlugSettingsRouteWithChildren
  '/_authenticated/$slug/': typeof AuthenticatedSlugIndexRoute
  '/_authenticated/$slug/settings/contacts': typeof AuthenticatedSlugSettingsContactsRoute
  '/_authenticated/$slug/settings/debug': typeof AuthenticatedSlugSettingsDebugRoute
  '/_authenticated/$slug/settings/import': typeof AuthenticatedSlugSettingsImportRoute
  '/_authenticated/$slug/settings/organization': typeof AuthenticatedSlugSettingsOrganizationRoute
  '/_authenticated/$slug/settings/properties': typeof AuthenticatedSlugSettingsPropertiesRoute
  '/_authenticated/$slug/settings/segments': typeof AuthenticatedSlugSettingsSegmentsRoute
  '/_authenticated/$slug/settings/templates': typeof AuthenticatedSlugSettingsTemplatesRoute
  '/_authenticated/$slug/settings/': typeof AuthenticatedSlugSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/$slug/broadcasts'
    | '/$slug/lobby'
    | '/$slug/maintenance'
    | '/$slug/messages'
    | '/$slug/packages'
    | '/$slug/settings'
    | '/$slug/'
    | '/$slug/settings/contacts'
    | '/$slug/settings/debug'
    | '/$slug/settings/import'
    | '/$slug/settings/organization'
    | '/$slug/settings/properties'
    | '/$slug/settings/segments'
    | '/$slug/settings/templates'
    | '/$slug/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug/broadcasts'
    | '/$slug/lobby'
    | '/$slug/maintenance'
    | '/$slug/messages'
    | '/$slug/packages'
    | '/$slug'
    | '/$slug/settings/contacts'
    | '/$slug/settings/debug'
    | '/$slug/settings/import'
    | '/$slug/settings/organization'
    | '/$slug/settings/properties'
    | '/$slug/settings/segments'
    | '/$slug/settings/templates'
    | '/$slug/settings'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/$slug'
    | '/_authenticated/$slug/broadcasts'
    | '/_authenticated/$slug/lobby'
    | '/_authenticated/$slug/maintenance'
    | '/_authenticated/$slug/messages'
    | '/_authenticated/$slug/packages'
    | '/_authenticated/$slug/settings'
    | '/_authenticated/$slug/'
    | '/_authenticated/$slug/settings/contacts'
    | '/_authenticated/$slug/settings/debug'
    | '/_authenticated/$slug/settings/import'
    | '/_authenticated/$slug/settings/organization'
    | '/_authenticated/$slug/settings/properties'
    | '/_authenticated/$slug/settings/segments'
    | '/_authenticated/$slug/settings/templates'
    | '/_authenticated/$slug/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$slug': {
      id: '/_authenticated/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof AuthenticatedSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$slug/': {
      id: '/_authenticated/$slug/'
      path: '/'
      fullPath: '/$slug/'
      preLoaderRoute: typeof AuthenticatedSlugIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/settings': {
      id: '/_authenticated/$slug/settings'
      path: '/settings'
      fullPath: '/$slug/settings'
      preLoaderRoute: typeof AuthenticatedSlugSettingsRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/packages': {
      id: '/_authenticated/$slug/packages'
      path: '/packages'
      fullPath: '/$slug/packages'
      preLoaderRoute: typeof AuthenticatedSlugPackagesRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/messages': {
      id: '/_authenticated/$slug/messages'
      path: '/messages'
      fullPath: '/$slug/messages'
      preLoaderRoute: typeof AuthenticatedSlugMessagesRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/maintenance': {
      id: '/_authenticated/$slug/maintenance'
      path: '/maintenance'
      fullPath: '/$slug/maintenance'
      preLoaderRoute: typeof AuthenticatedSlugMaintenanceRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/lobby': {
      id: '/_authenticated/$slug/lobby'
      path: '/lobby'
      fullPath: '/$slug/lobby'
      preLoaderRoute: typeof AuthenticatedSlugLobbyRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/broadcasts': {
      id: '/_authenticated/$slug/broadcasts'
      path: '/broadcasts'
      fullPath: '/$slug/broadcasts'
      preLoaderRoute: typeof AuthenticatedSlugBroadcastsRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/settings/': {
      id: '/_authenticated/$slug/settings/'
      path: '/'
      fullPath: '/$slug/settings/'
      preLoaderRoute: typeof AuthenticatedSlugSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/templates': {
      id: '/_authenticated/$slug/settings/templates'
      path: '/templates'
      fullPath: '/$slug/settings/templates'
      preLoaderRoute: typeof AuthenticatedSlugSettingsTemplatesRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/segments': {
      id: '/_authenticated/$slug/settings/segments'
      path: '/segments'
      fullPath: '/$slug/settings/segments'
      preLoaderRoute: typeof AuthenticatedSlugSettingsSegmentsRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/properties': {
      id: '/_authenticated/$slug/settings/properties'
      path: '/properties'
      fullPath: '/$slug/settings/properties'
      preLoaderRoute: typeof AuthenticatedSlugSettingsPropertiesRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/organization': {
      id: '/_authenticated/$slug/settings/organization'
      path: '/organization'
      fullPath: '/$slug/settings/organization'
      preLoaderRoute: typeof AuthenticatedSlugSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/import': {
      id: '/_authenticated/$slug/settings/import'
      path: '/import'
      fullPath: '/$slug/settings/import'
      preLoaderRoute: typeof AuthenticatedSlugSettingsImportRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/debug': {
      id: '/_authenticated/$slug/settings/debug'
      path: '/debug'
      fullPath: '/$slug/settings/debug'
      preLoaderRoute: typeof AuthenticatedSlugSettingsDebugRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
    '/_authenticated/$slug/settings/contacts': {
      id: '/_authenticated/$slug/settings/contacts'
      path: '/contacts'
      fullPath: '/$slug/settings/contacts'
      preLoaderRoute: typeof AuthenticatedSlugSettingsContactsRouteImport
      parentRoute: typeof AuthenticatedSlugSettingsRoute
    }
  }
}

interface AuthenticatedSlugSettingsRouteChildren {
  AuthenticatedSlugSettingsContactsRoute: typeof AuthenticatedSlugSettingsContactsRoute
  AuthenticatedSlugSettingsDebugRoute: typeof AuthenticatedSlugSettingsDebugRoute
  AuthenticatedSlugSettingsImportRoute: typeof AuthenticatedSlugSettingsImportRoute
  AuthenticatedSlugSettingsOrganizationRoute: typeof AuthenticatedSlugSettingsOrganizationRoute
  AuthenticatedSlugSettingsPropertiesRoute: typeof AuthenticatedSlugSettingsPropertiesRoute
  AuthenticatedSlugSettingsSegmentsRoute: typeof AuthenticatedSlugSettingsSegmentsRoute
  AuthenticatedSlugSettingsTemplatesRoute: typeof AuthenticatedSlugSettingsTemplatesRoute
  AuthenticatedSlugSettingsIndexRoute: typeof AuthenticatedSlugSettingsIndexRoute
}

const AuthenticatedSlugSettingsRouteChildren: AuthenticatedSlugSettingsRouteChildren =
  {
    AuthenticatedSlugSettingsContactsRoute:
      AuthenticatedSlugSettingsContactsRoute,
    AuthenticatedSlugSettingsDebugRoute: AuthenticatedSlugSettingsDebugRoute,
    AuthenticatedSlugSettingsImportRoute: AuthenticatedSlugSettingsImportRoute,
    AuthenticatedSlugSettingsOrganizationRoute:
      AuthenticatedSlugSettingsOrganizationRoute,
    AuthenticatedSlugSettingsPropertiesRoute:
      AuthenticatedSlugSettingsPropertiesRoute,
    AuthenticatedSlugSettingsSegmentsRoute:
      AuthenticatedSlugSettingsSegmentsRoute,
    AuthenticatedSlugSettingsTemplatesRoute:
      AuthenticatedSlugSettingsTemplatesRoute,
    AuthenticatedSlugSettingsIndexRoute: AuthenticatedSlugSettingsIndexRoute,
  }

const AuthenticatedSlugSettingsRouteWithChildren =
  AuthenticatedSlugSettingsRoute._addFileChildren(
    AuthenticatedSlugSettingsRouteChildren,
  )

interface AuthenticatedSlugRouteChildren {
  AuthenticatedSlugBroadcastsRoute: typeof AuthenticatedSlugBroadcastsRoute
  AuthenticatedSlugLobbyRoute: typeof AuthenticatedSlugLobbyRoute
  AuthenticatedSlugMaintenanceRoute: typeof AuthenticatedSlugMaintenanceRoute
  AuthenticatedSlugMessagesRoute: typeof AuthenticatedSlugMessagesRoute
  AuthenticatedSlugPackagesRoute: typeof AuthenticatedSlugPackagesRoute
  AuthenticatedSlugSettingsRoute: typeof AuthenticatedSlugSettingsRouteWithChildren
  AuthenticatedSlugIndexRoute: typeof AuthenticatedSlugIndexRoute
}

const AuthenticatedSlugRouteChildren: AuthenticatedSlugRouteChildren = {
  AuthenticatedSlugBroadcastsRoute: AuthenticatedSlugBroadcastsRoute,
  AuthenticatedSlugLobbyRoute: AuthenticatedSlugLobbyRoute,
  AuthenticatedSlugMaintenanceRoute: AuthenticatedSlugMaintenanceRoute,
  AuthenticatedSlugMessagesRoute: AuthenticatedSlugMessagesRoute,
  AuthenticatedSlugPackagesRoute: AuthenticatedSlugPackagesRoute,
  AuthenticatedSlugSettingsRoute: AuthenticatedSlugSettingsRouteWithChildren,
  AuthenticatedSlugIndexRoute: AuthenticatedSlugIndexRoute,
}

const AuthenticatedSlugRouteWithChildren =
  AuthenticatedSlugRoute._addFileChildren(AuthenticatedSlugRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedSlugRoute: typeof AuthenticatedSlugRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSlugRoute: AuthenticatedSlugRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
